import { typographyLabelSmallPrimaryRegular } from 'common-ui/typography';
import { styled } from 'style/ORSNNTheme';
import { Dialog, DialogProps } from 'ui-kit';

import { DealRole } from '__generated__/globalTypes';
import { GetDealDiligence_deal_diligence_collateral } from 'query/__generated__/GetDealDiligence';

import { CloseButton, CompactDialogContainer } from './commonStyles';
import { FileDiligenceStatus, FileStatusDropdown } from './FileStatus';

interface QuickStatusDialogProps {
  loanName: string;
  collateral: GetDealDiligence_deal_diligence_collateral[];
  dialog: DialogProps;
  role: DealRole;
  onStatusChange: (
    dealId: string,
    loanId: string,
    fileName: string,
    status: FileDiligenceStatus,
  ) => void;
}

export const QuickStatusDialog = ({
  dialog,
  collateral,
  loanName,
  role,
  onStatusChange,
}: QuickStatusDialogProps) => {
  const isSeller = role === DealRole.SELLER;

  return (
    <Dialog dialog={dialog} contentComponent={CompactDialogContainer}>
      <h1 className="relative mx-0 mb-[10px] mt-[3px] p-0 text-[12px] font-medium leading-[16px] tracking-[0] text-[#afafaf] [font-family:Heebo,sans-serif]">
        {isSeller ? 'View Documents Status' : 'View/Edit Documents Status'} for "{loanName}"
        <CloseButton onClick={() => dialog.setIsOpen(false)} />
      </h1>
      <div>Total: {collateral.length} Documents</div>
      <DocumentList>
        {collateral.map((collateral) => (
          <DocumentRow key={collateral.collateralID}>
            <DocumentName>{collateral.fileName}</DocumentName>
            <div style={{ width: '220px' }}>
              {collateral.collateralStatus && (
                <FileStatusDropdown
                  isInSelectedRow={false}
                  value={collateral.collateralStatus}
                  borderColor="#616161"
                  isDisabled={isSeller}
                  onChange={(status) =>
                    collateral.loanID &&
                    onStatusChange(
                      collateral.dealID,
                      collateral.loanID,
                      collateral.fileName,
                      status,
                    )
                  }
                />
              )}
            </div>
          </DocumentRow>
        ))}
      </DocumentList>
    </Dialog>
  );
};

const DocumentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const DocumentName = styled.div`
  ${typographyLabelSmallPrimaryRegular}
  width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DocumentRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;

  ${typographyLabelSmallPrimaryRegular}
`;
